<template>
    <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100 items-center justify-center">

        <div class="flex flex-col items-center justify-center p-5">
            <img src="@/assets/images/papsi-no-events.png" class="w-[15%] opacity-75 mb-2">
            <p class="font-medium text-gray-600 text-lg lg:text-2xl px-0 sm:px-8 md:px-16 lg:px-32">No Events Yet</p>
            <p class="text-sm lg:text-base text-gray-500 px-0 sm:px-8 md:px-16 lg:px-32 mt-2">We don’t have any events at the moment, but new ones are coming soon. Stay tuned, mga Ka-May-Ari!</p>
        </div>

        <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
            :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
            @positiveClick="handlePositiveClick()" @negativeClick="show_message_modal = false"
            :positiveButton="positiveBtn" :negativeButton="negativeBtn" :default_width="'max-w-xl'" id='vote_modal'>
            <div class="w-full px-5 pt-2 pb-4 flex flex-col justify-center text-center items-center">
                {{ this.modal_message }}
            </div>
        </ModalControl>

    </div>
</template>
<script>
import { defineComponent } from 'vue';
import ModalControl from '@/components/controls/ModalControl.vue';
import User from "@/services/User";
import mixin from '@/mixin';

export default defineComponent({
    components: {
        ModalControl,
    },
    mixins: [mixin],
    inject: ['setLoading'],
    mounted() {
        let that = this;
        const state = that.$store.state;

        if (!state.credentials.username) {
            that.getUserInfo();
        } else {
            that.checkUserFlow();
        }

    },
    data() {
        return {
            show_message_modal: false,
            modal_message: '',
            success: false,
            warning: false,
            error: false,
            question: false,
            expired: false,
            positiveBtn: 'Okay',
        }
    },
    methods: {
        getUserInfo() {
            let that = this;
            const cookie = that.$cookies;
            const store = that.$store;
            let state = store.state;
            that.setLoading(true);

            User.recoverSession(cookie.get('user_session').hash).then(function (response) {
                let data = response.data.data;
                state.logged = true;
                state.credentials.first_name = data.info.first_name;
                state.credentials.last_name = data.info.last_name;
                state.credentials.middle_name = data.info.middle_name;
                state.credentials.regular = data.info.regular;
                state.credentials.express = data.express;
                state.credentials.pso_enroll = data.pso_enroll;
                state.credentials.pin_update = data.pin_update;
                state.credentials.membership_date = data.info.membership_date || null;
                state.credentials.status = data.status || null;
                state.credentials.account_no = data.info.account_number;
                state.gaUser = data.ga;
                state.credentials.email = data.info.email;
                state.credentials.gender = data.info.gender;
                state.credentials.birthdate = data.info.date_of_birth;
                state.credentials.age = data.info.age;
                state.credentials.membership_type = data.info.membership_type;
                state.credentials.registered_date = data.info.registered;
                state.credentials.key = data.key;
                state.credentials.mobile = data.info.mobile;
                state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
                state.credentials.suffix = data.info.suffix ?? '';
                state.credentials.qr = data.qr;
                state.credentials.uuid = data.uuid;
                state.credentials.serial_no = data.info.serial_number;
                state.credentials.timestamp = response.timestamp;
                state.credentials.username = data.info.username;
                state.credentials.hash = data.hash;
                state.credentials.has_pin = data.has_pin;
                state.credentials.deactivated = data.deactivated;
                state.credentials.tin = data.info.tin;
                const type2Config = data.config.find(item => item.type === 2);
                if (type2Config) {
                    state.credentials.config = { status: type2Config.status };
                } else {
                    state.credentials.config = null;
                }
                that.account_number = state.credentials.account_no;
                that.full_name = state.credentials.name;
                that.gender = state.credentials.gender;
                that.Astatus = state.credentials.status;
                that.Membership = state.credentials.membership_type;
                that.Member_since = state.credentials.membership_date;
                that.email = state.credentials.email;
                that.mobile = state.credentials.mobile;
                that.tin = state.credentials.tin;
                that.age = state.credentials.age;
                that.birthdate = state.credentials.birthdate;
                that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
                that.username = state.credentials.username;
                that.registered = state.credentials.registered_date;
                that.qr = data.qr;
                that.currentTin = state.credentials.tin;
                that.express = data.express;
                that.deactivated = data.deactivated;
                const rawRegisteredDate = state.credentials.registered_date;
                if (rawRegisteredDate) {
                    const parts = rawRegisteredDate.split('-');
                    that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                const rawBirthdate = state.credentials.birthdate;
                if (rawBirthdate) {
                    const parts = rawBirthdate.split('-');
                    that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
                }

                that.checkUserFlow();
                that.setLoading(false);

            }).catch(function (error) {
                that.error = true;
                that.setLoading(false);
                that.show_message_modal = true;
                that.modal_message = error.response.data.message;
                if (error.response.status == 403) {
                    that.expired = true
                    that.modal_message = "Your session has expired. Please log in again.";
                    that.$store.state.logged = false;
                }
            });
        },
        checkUserFlow() {
            const that = this;
            const state = that.$store.state;
            const noContact = !state.credentials.mobile || !state.credentials.email;
            const config = state.credentials.config;
            const temporaryPIN = state.credentials.pin_update;
            const isValidated = that.$cookies.get('validated');

            if (state.credentials.deactivated) {
                this.$router.push('/user/settings');
                return;
            }

            if (noContact) {
                state.credentials.noContact = noContact;
                this.show_update = true;
                return;
            }

            if (state.credentials.enrolled_pin) {
                const hasValidConfig = config && config.status;
                const noContact = state.credentials.noContact;
                state.credentials.enrolled_pin = false;

                if (noContact) {
                    that.show_update = false;
                    that.show_pin_modal = false;
                    that.show_otp_modal = false;
                    that.$cookies.set('validated', true);
                } else {
                    if (hasValidConfig) {
                        that.requestOTP();
                    } else {
                        that.show_update = false;
                        that.show_pin_modal = false;
                        that.show_otp_modal = false;
                        that.$cookies.set('validated', true);
                    }
                }
                return;
            }


            if (!isValidated) {
                if (state.credentials.has_pin) {
                    this.show_pin_modal = true;
                } else {
                    this.$router.push('/user/settings');
                }
            }

            if (temporaryPIN) {
                this.$router.push('/user/settings');
                state.credentials.edit_temporary = true;
                return;
            }

            const missingInfo = !state.credentials.mobile || !state.credentials.email ||
                !state.credentials.tin || !state.credentials.birthdate;

            if (missingInfo && !that.$cookies.get('skipped')) {
                this.show_update = true;
            }
        },
        handlePositiveClick() {
            if (this.expired) {
                this.closed();
            } else {
                this.show_message_modal = false;
                this.negativeBtn = null;
            }
        },
        closed() {
            let that = this;
            that.$cookies.remove('user');
            that.$cookies.remove('user_session');
            that.$router.push('/');
            that.show_message_modal = false;
        },

    },
})
</script>
<style scoped>
.max-width-back {
    max-width: 50px;
}
</style>
